import type { NotVerifiedAsset } from './AssetLabelService';
import { Stack, Typography, Chip } from '@mui/joy';
import { useTheme } from '@mui/joy/styles';
import type { CSSProperties, ReactNode } from 'react';

interface AssetsChipListProps {
  assets: NotVerifiedAsset[];
  height: CSSProperties['height'];
  error?: string;
  placeholder?: string;
  renderItem: (asset: NotVerifiedAsset) => ReactNode;
}

export const AssetsChipList = ({ assets, height, error, placeholder, renderItem }: AssetsChipListProps) => {
  const theme = useTheme();
  return (
    <Stack
      width="100%"
      direction="row"
      sx={{
        alignItems: 'center',
        alignContent: 'flex-start',
        flexWrap: 'wrap',
        padding: 0.5,
        gap: 0.5,
        overflow: 'auto',
        height: height,
        borderRadius: theme.radius.md,
        border: `1px solid ${error ? theme.palette.danger.outlinedBorder : theme.palette.divider}`,
      }}
    >
      {assets.length === 0 && placeholder && (
        <Typography
          sx={{
            color: `rgba(${theme.vars.palette.neutral.mainChannel} / 0.8)`,
          }}
          level="body-sm"
        >
          {placeholder}
        </Typography>
      )}
      {assets.map((asset: NotVerifiedAsset) => (
        <Chip
          key={asset.id}
          sx={{ cursor: 'default' }}
          slotProps={{ label: { sx: { display: 'flex' } } }}
          variant="outlined"
        >
          {renderItem(asset)}
        </Chip>
      ))}
    </Stack>
  );
};

export default AssetsChipList;
